<template>
    <div v-if="showTable" id="table-pendientes">
        <!-- Tipo de tabla sin agrupamiento-->
        <el-table v-if="tipoTabla == 1"
        style="width: 100%"
        border
        :data="datosTabla"
        row-class-name="classTablaPendientes"
        header-row-class-name="table-header"
        :cell-style="coloreoReferencia"
        v-loading="loading"
        :show-summary="true"
        :summary-method="getSummaries"
        ref="tablaPendientes"
        id="tablaPendientes"
        :empty-text="$t('EL_TABLE_sin_datos')"
        >
        
            <el-table-column
                :label="$t('PENDIENTES_vencimiento')"
                prop="Vencimiento"
            >
                <template slot-scope="scope">
                    {{ scope.row.Vencimiento | formatDate }}
                </template>
            </el-table-column>
            <!--<el-table-column
                :label="$t('PENDIENTES_tipo')"
                prop="Tipo"
            >
            </el-table-column>
            <el-table-column
                :label="$t('PENDIENTES_serie')"
                prop="Serie"
            >
            </el-table-column>
            <el-table-column
                :label="$t('PENDIENTES_punto_venta')"
                prop="PuntoDeVenta"
                width="100"
            >
            </el-table-column>
            <el-table-column
                :label="$t('PENDIENTES_numero')"
                prop="Numero"
            >
            </el-table-column>-->
            <el-table-column
                :label="$t('RESUMENDECUENTA_tabla_documento')"
                prop="Documento"
                width="200"
            >
                <template slot-scope="scope">
                    {{ scope.row.Documento}}
                </template>
            </el-table-column>
            <el-table-column
                :label="$t('PENDIENTES_cuotas')"
                prop="Cuotas"
            >
                <template slot-scope="scope">
                    {{ scope.row.Cuotas}}
                </template>
            </el-table-column>
            <el-table-column
                :label="$t('PENDIENTES_debe')"
                prop="Debe"
                width="200"
                align="right"
            >
                <template slot-scope="scope">
                    {{ scope.row.Debe | formatPrice}}
                </template>
            </el-table-column>
            <el-table-column
                :label="$t('PENDIENTES_haber')"
                prop="Haber"
                width="200"
                align="right"
            >
                <template slot-scope="scope">
                    {{ scope.row.Haber | formatPrice}}
                </template>
            </el-table-column>
            
        </el-table>

        <!-- Tipo de tabla agrupamiento por semana-->
        <el-table v-else-if="tipoTabla == 2"
        style="width: 100%"
        border
        :data="datosTabla"
        header-row-class-name="table-header"
        row-class-name="classTablaPendientes"
        v-loading="loading"
        :show-summary="true"
        :summary-method="getSummaries"
        ref="tablaPendientes"
        :empty-text="$t('EL_TABLE_sin_datos')"
        >
            <el-table-column
                :label="$t('PENDIENTES_semana')"
                prop="Semana"
            >
                <template slot-scope="scope">
                    {{ scope.row.Semana}}
                </template>
            </el-table-column>
            <el-table-column
                :label="$t('PENDIENTES_desde')"
                prop="Desde"
            >
                <template slot-scope="scope">
                    {{ scope.row.Desde}}
                </template>
            </el-table-column>
            <el-table-column
                :label="$t('PENDIENTES_hasta')"
                prop="Hasta"
            >
                <template slot-scope="scope">
                    {{ scope.row.Hasta}}
                </template>
            </el-table-column>
            <el-table-column
                :label="$t('PENDIENTES_debe')"
                prop="Debe"
                align="right"
            >
                <template slot-scope="scope">
                    {{ scope.row.Debe | formatPrice}}
                </template>
            </el-table-column>
            <el-table-column
                :label="$t('PENDIENTES_haber')"
                prop="Haber"
                align="right"
            >
                <template slot-scope="scope">
                    {{ scope.row.Haber | formatPrice}}
                </template>
            </el-table-column>
        </el-table>

        <!-- Tipo de tabla agrupamiento por mes-->
        <el-table v-else
        style="width: 100%;"
        border
        :data="datosTabla"
        header-row-class-name="table-header"
        row-class-name="classTablaPendientes"
        v-loading="loading"
        :show-summary="true"
        :summary-method="getSummaries"
        ref="tablaPendientes"
        :empty-text="$t('EL_TABLE_sin_datos')"
        >
            <el-table-column
                prop="MesLabel"
                :label="$t('PENDIENTES_mes')"
                >
                <template slot-scope="scope">
                    {{ scope.row.Mes}}/{{scope.row.Anio}}
                </template>
            </el-table-column>
            <el-table-column
                prop="Debe"
                :label="$t('PENDIENTES_debe')"
                align="right"
                >
                <template slot-scope="scope">
                    {{ scope.row.Debe | formatPrice}}
                </template>
            </el-table-column>
            <el-table-column
                prop="Haber"
                :label="$t('PENDIENTES_haber')"
                align="right"
                >
                <template slot-scope="scope">
                    {{ scope.row.Haber | formatPrice}}
                </template>
            </el-table-column>
        </el-table>

    </div>
    
</template>

<script>
export default {
    name: "TablaPendientes",
    props: {
        cuentaCorriente: String,
        formaDePago: String,
        tipoTabla: Number,
        datos: {
            type: Array,
            default: () => []
        },
        loading: {
            type: Boolean,
            default: false
        },
        showTable: {
            type: Boolean,
            default: true
        },
        totalDebe: {
            type: Number,
            default: 0
        },
        totalHaber: {
            type: Number,
            default: 0
        }
    },
    data(){
        return{

        }
    },
    computed: {
        datosTabla(){
            return this.datos;
        },
        agrupamiento(){
            if(this.tipoTabla == 1){
                let stringAgrupamiento  = this.$t('PENDIENTES_datos_agrupados_por') + ": " + this.$t('PENDIENTES_sin_agrupar');
                return stringAgrupamiento;
            }else if (this.tipoTabla == 2){
                let stringAgrupamiento = this.$t('PENDIENTES_datos_agrupados_por') + ": " + this.$t('PENDIENTES_semana')
                return stringAgrupamiento;
            }else{
                let stringAgrupamiento = this.$t('PENDIENTES_datos_agrupados_por') + ": " + this.$t('PENDIENTES_mes')
                return stringAgrupamiento;
            }
        },
        labelCuentaCorriente(){
            return this.$t('PENDIENTES_cuenta_corrientes') + ": " + this.cuentaCorriente;
        },
    },
    methods:{
        esColumnaDebeHaber(nombreColumna) {
            return (!nombreColumna) ?false :(nombreColumna == this.$t('PENDIENTES_debe') || nombreColumna == this.$t('PENDIENTES_haber'))
        },
        //Metodo para Colorear el estado del Pendiente: Rojo = Vencido, Amarillo=Por vencer
        coloreoReferencia ({row, column, rowIndex, columnIndex}) {
            if (column.label === this.$t('PENDIENTES_vencimiento')) {
                switch (row.Coloreado) {
                    case "R":
                    return {
                    background: '#ffbbbb'
                    }
                    case "A":
                    return {
                    background: '#ffffbb'
                    }    
                    default:
                    return {
                    background: '#ffffff'
                    }
                }       
            }
        },
        /*
        tableRowClassName({row}) {
            let className = ''
            if (row.Coloreado == 'R') className= 'vencido'
            if (row.Coloreado == 'A') className= 'pendiente'
            return className
        },
        */
        getSummaries(param) {
                  // #g1
        const { columns, data } = param;
        const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = this.$t("RESUMENDECUENTA_tabla_totales");
                    return;
                }
                if (column.property === "Debe") {
                    sums[index] = this.$options.filters.formatPrice(this.totalDebe);
                }
                if (column.property === "Haber") {
                    sums[index] = this.$options.filters.formatPrice(this.totalHaber);
                }
            });
        return sums;
        },
        summariesActivo(data, activo) {
            const values = data.map((item) => Number(item[activo]));
            if (!values.every((value) => isNaN(value))) {
                let activoValue = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value) && value != -1) {
                    return prev + curr;
                } else {
                    return prev;
                }
                }, 0);

                return activoValue;
            } else {
                return "N/A";
            }
        }
        }
    }
</script>

<style scoped>

.el-table {
    margin-top: 1rem;
}

</style>

<style>
.el-table .classTablaPendientes td, .el-table .classTablaPendientes th {
    padding: 5px 0;
}

</style>
